import { TASKS, drawer_catalog } from './my_tasks.data.js';
import {
  create_new_task_form,
  create_edit_task_form,
  new_task_owner_options,
  new_task_category_options,
  new_task_status_options,
  new_task_escalation_options,
  new_task_source_event_options,
  new_task_domain_options,
  my_tasks_computed,
  my_tasks_methods
} from './my_tasks.helpers.js';

export default {
  name: 'MyTasks',
  data: () => ({
    active_filter: 'all',
    tasks: TASKS,
    active_role: 'compliance_officer',
    view_mode: 'category',
    active_drawer_key: null,
    drawer_catalog,
    show_new_task_modal: false,
    show_edit_task_modal: false,
    edit_task_id: null,
    new_task_form: create_new_task_form(),
    edit_task_form: create_edit_task_form(),
    new_task_owner_options,
    new_task_category_options,
    new_task_status_options,
    new_task_escalation_options,
    new_task_source_event_options,
    new_task_domain_options
  }),
  computed: my_tasks_computed,
  methods: my_tasks_methods
};
